// Generado por scripts/extract-i18n.mjs — no editar a mano.
import es from './es.json';
import en from './en.json';
import de from './de.json';
import fr from './fr.json';
import it from './it.json';
import nl from './nl.json';
import pl from './pl.json';
import ro from './ro.json';
import pt from './pt.json';
import ru from './ru.json';
import uk from './uk.json';
import sv from './sv.json';
import nb from './no.json';
import da from './da.json';
import cs from './cs.json';
import hu from './hu.json';

import type { Language } from '../types';

export const LANGUAGES = {
  es: es as unknown as Language,
  en: en as unknown as Language,
  de: de as unknown as Language,
  fr: fr as unknown as Language,
  it: it as unknown as Language,
  nl: nl as unknown as Language,
  pl: pl as unknown as Language,
  ro: ro as unknown as Language,
  pt: pt as unknown as Language,
  ru: ru as unknown as Language,
  uk: uk as unknown as Language,
  sv: sv as unknown as Language,
  no: nb as unknown as Language,
  da: da as unknown as Language,
  cs: cs as unknown as Language,
  hu: hu as unknown as Language,
} as const;

export type LanguageCode = keyof typeof LANGUAGES;
export const LANGUAGE_CODES = Object.keys(LANGUAGES) as LanguageCode[];
